import * as v from 'valibot';
import Ajax from '../util/ajax';
import { deviceAdded } from '../features/devices/devicesSlice';
import { deviceSchema } from '../types/device';
export function createDeviceZigbee(node_id, endpoint_id, title) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        const url = '/device/create/zigbee';
        const obj = {
            node_id,
            endpoint_id,
            title
        };
        ajax.post(url, obj, data => {
            const res = v.safeParse(deviceSchema, data);
            if (res.success) {
                dispatch(deviceAdded(res.output));
            }
            else {
                console.error(v.summarize(res.issues));
            }
        });
    };
}
